export * from './lib/flash-briefing-ui.module';
